export const COOKIE_CONSENT_STORAGE_KEY = 'cookie_consent'
